import { v4 as uuidv4 } from 'uuid';
import { getLocalStorage } from './storage';
import { getCustomData } from './customData';
import { ExperienceDetails } from 'types/ProductDetailsType';
import { getSessionIdFromCookie } from './identifierCookies';

export enum PossibleGtmEventNames {
  CONTENT_GATE_CHECKED = 'contentGateChecked',
  REGISTRATION_INITIATION = 'registrationInitiation',
  REGISTRATION_SUBMISSION = 'registrationSubmission',
}

export type RegistrationSubmissionEventData = {
  customerData: Record<string, any>;
  registrationData: Record<string, any>;
  experienceData: Record<string, any>;
};

const getCommonEventEnvelope = () => {
  const sessionId: string = getSessionIdFromCookie();
  const gdprRegion: boolean =
    Intl.DateTimeFormat().resolvedOptions().timeZone.indexOf('Europe') === 0 ||
    false;

  const customDataObject = getCustomData();
  const hasCustomData = Object.keys(customDataObject).length > 0;
  const customData = hasCustomData
    ? Object.entries(customDataObject).map(([key, value]) => ({
        key,
        value,
      }))
    : [];

  return {
    eventId: uuidv4(),
    sessionId,
    gdprRegion,
    ...(hasCustomData && { customData }),
  };
};

const pushToDataLayer = (eventName: string, payload: Record<string, any>) => {
  const w: any = window;
  if (!w?.dataLayer) return;

  const fullPayload = {
    event: `brij.${eventName}`,
    ...payload,
  };

  w.dataLayer.push(fullPayload);
};

const logGtmEvent = (eventName: PossibleGtmEventNames, user?: any) => {
  const userDateOfBirth: string =
    getLocalStorage().getItem('ageGateBirthDate') || '';
  const details = JSON.parse(
    getLocalStorage().getItem('brijProductDetails') || '{}'
  );
  const experienceDetails: ExperienceDetails =
    details?.product?.experienceDetails;

  pushToDataLayer(eventName, {
    ...getCommonEventEnvelope(),
    ...(experienceDetails && { experienceDetails }),
    user: {
      ...user,
      ...(userDateOfBirth && { dateOfBirth: userDateOfBirth }),
    },
  });
};

export const logRegistrationSubmissionGtmEvent = (
  payload: RegistrationSubmissionEventData
) => {
  pushToDataLayer(PossibleGtmEventNames.REGISTRATION_SUBMISSION, {
    ...getCommonEventEnvelope(),
    experienceData: payload.experienceData,
    customerData: payload.customerData,
    registrationData: payload.registrationData,
  });
};

export default logGtmEvent;
